<template>
  <div class="settings columns container">
    <div v-if="!showOnlyRestartButton()">
      <setting-intro-banner
        :header-image="inbox.avatarUrl"
        :header-title="inboxName"
      >
        <woot-tabs
          class="settings--tabs"
          :index="selectedTabIndex"
          :border="false"
          @change="onTabChange"
        >
          <woot-tabs-item
            v-for="tab in tabs"
            :key="tab.key"
            :name="tab.name"
            :show-badge="false"
          />
        </woot-tabs>
      </setting-intro-banner>

      <div v-if="selectedTabKey === 'inbox_settings'" class="settings--content">
        <settings-section
          :title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_TITLE')"
          :sub-title="$t('INBOX_MGMT.SETTINGS_POPUP.INBOX_UPDATE_SUB_TEXT')"
        >
          <woot-avatar-uploader
            :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_AVATAR.LABEL')"
            :src="avatarUrl"
            class="settings-item"
            delete-avatar
            @change="handleImageUpload"
            @onAvatarDelete="handleAvatarDelete"
          />
          <woot-input
            v-model.trim="selectedInboxName"
            class="medium-9 columns settings-item"
            :class="{ error: $v.selectedInboxName.$error }"
            :label="inboxNameLabel"
            :placeholder="inboxNamePlaceHolder"
            :error="
              $v.selectedInboxName.$error
                ? $t('INBOX_MGMT.ADD.CHANNEL_NAME.ERROR')
                : ''
            "
            @blur="$v.selectedInboxName.$touch"
          />
          <label
            v-if="isATwitterInbox"
            for="toggle-business-hours"
            class="toggle-input-wrap"
          >
            <input
              v-model="tweetsEnabled"
              type="checkbox"
              name="toggle-business-hours"
            />
            {{ $t('INBOX_MGMT.ADD.TWITTER.TWEETS.ENABLE') }}
          </label>
          <!-- <woot-input
          v-if="isAPIInbox"
          v-model.trim="webhookUrl"
          class="medium-9 columns settings-item"
          :class="{ error: $v.webhookUrl.$error }"
          :label="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.LABEL')
          "
          :placeholder="
            $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.PLACEHOLDER')
          "
          :error="
            $v.webhookUrl.$error
              ? $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WEBHOOK_URL.ERROR')
              : ''
          "
          @blur="$v.webhookUrl.$touch"
        /> -->
          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.SESSION_ID') }}
            <input v-model="sessionId" type="text" disabled />
          </label>

          <label
            v-if="isAWebWidgetInbox"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.WIDGET_COLOR.LABEL') }}
            <woot-color-picker v-model="inbox.widget_color" />
          </label>

          <label
            v-if="isAWhatsAppChannel"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.LABEL') }}
            <input v-model="whatsAppAPIProviderName" type="text" disabled />
          </label>

          <label class="medium-9 columns settings-item">
            {{
              $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.LABEL')
            }}
            <select v-model="greetingEnabled">
              <option :value="true">
                {{
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.ENABLED'
                  )
                }}
              </option>
              <option :value="false">
                {{
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.DISABLED'
                  )
                }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_TOGGLE.HELP_TEXT'
                )
              }}
            </p>
          </label>
          <div v-if="greetingEnabled" class="settings-item">
            <greetings-editor
              v-model.trim="greetingMessage"
              :label="
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_GREETING_MESSAGE.PLACEHOLDER'
                )
              "
              :richtext="!textAreaChannels"
            />
          </div>

          <woot-input
            v-if="isAWebWidgetInbox"
            v-model.trim="channelWebsiteUrl"
            class="medium-9 columns settings-item"
            :label="$t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.LABEL')"
            :placeholder="
              $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_DOMAIN.PLACEHOLDER')
            "
          />

          <woot-input
            v-if="isAWebWidgetInbox"
            v-model.trim="channelWelcomeTitle"
            class="medium-9 columns settings-item"
            :label="
              $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.LABEL')
            "
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TITLE.PLACEHOLDER'
              )
            "
          />

          <woot-input
            v-if="isAWebWidgetInbox"
            v-model.trim="channelWelcomeTagline"
            class="medium-9 columns settings-item"
            :label="
              $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.LABEL')
            "
            :placeholder="
              $t(
                'INBOX_MGMT.ADD.WEBSITE_CHANNEL.CHANNEL_WELCOME_TAGLINE.PLACEHOLDER'
              )
            "
          />

          <label
            v-if="isAWebWidgetInbox"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.TITLE') }}
            <select v-model="replyTime">
              <option key="in_a_few_minutes" value="in_a_few_minutes">
                {{
                  $t(
                    'INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_MINUTES'
                  )
                }}
              </option>
              <option key="in_a_few_hours" value="in_a_few_hours">
                {{
                  $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_FEW_HOURS')
                }}
              </option>
              <option key="in_a_day" value="in_a_day">
                {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.IN_A_DAY') }}
              </option>
            </select>

            <p class="help-text">
              {{ $t('INBOX_MGMT.ADD.WEBSITE_CHANNEL.REPLY_TIME.HELP_TEXT') }}
            </p>
          </label>

          <label
            v-if="isAWebWidgetInbox"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX') }}
            <select v-model="emailCollectEnabled">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.EMAIL_COLLECT_BOX.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT'
                )
              }}
            </p>
          </label>

          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CSAT') }}
            <select v-model="csatSurveyEnabled">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_CSAT.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_CSAT.DISABLED') }}
              </option>
            </select>
            <woot-input
              v-if="csatSurveyEnabled"
              v-model="csatCustomMessage"
              class="medium-9 columns settings-item"
              :label="
                $t('INBOX_MGMT.EDIT.ENABLE_CSAT.CSAT_CUSTOM_MESSAGE_LABEL')
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.EDIT.ENABLE_CSAT.CSAT_CUSTOM_MESSAGE_PLACEHOLDER'
                )
              "
            />
            <woot-input
              v-if="csatSurveyEnabled"
              v-model="csatSurveyMessage"
              class="medium-9 columns settings-item"
              :label="$t('INBOX_MGMT.EDIT.ENABLE_CSAT.CSAT_SURVEY_LABEL')"
              :placeholder="
                $t('INBOX_MGMT.EDIT.ENABLE_CSAT.CSAT_SURVEY_PLACEHOLDER')
              "
            />
            <p class="help-text">
              {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CSAT_SUB_TEXT') }}
            </p>
          </label>
          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_SLA') }}
            <select v-model="slaEnabled">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_SLA.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_SLA.DISABLED') }}
              </option>
            </select>
            {{ $t('INBOX_MGMT.EDIT.ENABLE_SLA.ACCOUNTANT') }}
            <select v-if="slaEnabled" v-model="slaTimerAccountant">
              <option
                v-for="item in OPTIONS_SELECT_ACCOUNTANT"
                :key="item.name"
                :value="item.id"
              >
                {{ item.name }}
              </option>
            </select>
            <woot-input
              v-if="slaEnabled"
              v-model="slaTimer"
              type="time"
              :class="{ error: $v.slaTimer.$error }"
              :error="
                $v.slaTimer.$error ? $t('INBOX_MGMT.EDIT.ENABLE_SLA.ERROR') : ''
              "
              class="medium-9 columns"
              :label="$t('INBOX_MGMT.EDIT.ENABLE_SLA.SLA_LABEL')"
              :placeholder="$t('INBOX_MGMT.EDIT.ENABLE_SLA.SLA_PLACEHOLDER')"
              @blur="$v.slaTimer.$touch"
            />
            <p class="help-text">
              {{ $t('INBOX_MGMT.EDIT.ENABLE_SLA.SLA_SUB_TEXT') }}
            </p>
          </label>

          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_UNASSIGNED_TIME') }}
            <select v-model="unassignedStatusTimeEnabled">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_UNASSIGNED_TIME.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_UNASSIGNED_TIME.DISABLED') }}
              </option>
            </select>
            <woot-input
              v-if="unassignedStatusTimeEnabled"
              v-model="unassignedTimer"
              type="time"
              :class="{ error: $v.unassignedTimer.$error }"
              :error="
                $v.unassignedTimer.$error
                  ? $t('INBOX_MGMT.EDIT.ENABLE_SLA.ERROR')
                  : ''
              "
              class="medium-9 columns"
              :label="
                $t(
                  'INBOX_MGMT.EDIT.ENABLE_UNASSIGNED_TIME.UNASSIGNED_TIME_LABEL'
                )
              "
              :placeholder="
                $t(
                  'INBOX_MGMT.EDIT.ENABLE_UNASSIGNED_TIME.UNASSIGNED_TIME_PLACEHOLDER'
                )
              "
              @blur="$v.unassignedTimer.$touch"
            />
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.EDIT.ENABLE_UNASSIGNED_TIME.UNASSIGNED_TIME_SUB_TEXT'
                )
              }}
            </p>
          </label>

          <label class="medium-9 columns settings-item">
            {{
              $t(
                'INBOX_MGMT.EDIT.ENABLE_ASSIGN_ON_MESSAGE.ASSIGNEE_ON_MESSAGE_LABEL'
              )
            }}
            <select v-model="assigneeOnSendMessage">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_ASSIGN_ON_MESSAGE.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_ASSIGN_ON_MESSAGE.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.EDIT.ENABLE_ASSIGN_ON_MESSAGE.ASSIGNEE_ON_MESSAGE_PLACEHOLDER'
                )
              }}
            </p>
          </label>

          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.EDIT.RESOLUTION_FIRST_CONTACT.LABEL') }}
            <select v-model="firstResponseResolution">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.RESOLUTION_FIRST_CONTACT.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.RESOLUTION_FIRST_CONTACT.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{ $t('INBOX_MGMT.EDIT.RESOLUTION_FIRST_CONTACT.DESCRIPTION') }}
            </p>
          </label>

          <label class="medium-9 columns settings-item">
            {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.LABEL') }}
            <select v-model="contactClassification">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.DESCRIPTION') }}
            </p>
            <div v-show="contactClassification">
              <input
                id="define_contact_attributes"
                v-model="classificationType"
                class="notification--checkbox"
                type="radio"
                value="contact_attributes"
                @input="handleClassificationType"
              />
              <label for="audio_enable_alert_all">
                {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.CONTACT_TAB') }}
              </label>
            </div>
            <div v-show="contactClassification">
              <input
                id="define_group_attributes"
                v-model="classificationType"
                class="notification--checkbox"
                type="radio"
                value="group_attributes"
                @input="handleClassificationType"
              />
              <label for="audio_enable_alert_all">
                {{ $t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.GROUP_TAB') }}
              </label>
            </div>
            <table v-show="contactClassification">
              <thead>
                <tr>
                  <th>{{ $t('INBOX_MGMT.EDIT.TABLE_HEADER.SOURCE') }}</th>
                  <th>{{ $t('INBOX_MGMT.EDIT.TABLE_HEADER.SITUATION') }}</th>
                  <th>{{ $t('INBOX_MGMT.EDIT.TABLE_HEADER.VALUE') }}</th>
                  <th>
                    {{ $t('INBOX_MGMT.EDIT.TABLE_HEADER.CLASSIFICATION') }}
                  </th>
                  <th>{{ $t('INBOX_MGMT.EDIT.TABLE_HEADER.ACTIONS') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in selectedClassificationTabIndex === 0
                    ? rows
                    : groupRows"
                  :key="row.id"
                >
                  <td>
                    <select
                      v-if="selectedClassificationTabIndex === 0"
                      v-model="row.custom_attribute"
                      @change="updateAttributeKey(row)"
                    >
                      <option
                        v-for="attribute in attributes"
                        :key="attribute.id"
                        :value="attribute.id"
                      >
                        {{ attribute.attribute_display_name }}
                      </option>
                    </select>
                    <select
                      v-else
                      v-model="row.custom_attribute"
                      @change="updateAttributeKey(row)"
                    >
                      <option
                        :key="groupAttributeData.company.name"
                        value="company"
                      >
                        {{ groupAttributeData.company.name }}
                      </option>
                      <option
                        :key="groupAttributeData.client_code.name"
                        value="client_code"
                      >
                        {{ groupAttributeData.client_code.name }}
                      </option>
                      <option
                        :key="groupAttributeData.status.name"
                        value="status"
                      >
                        {{ groupAttributeData.status.name }}
                      </option>
                      <option
                        :key="groupAttributeData.monthly_fee.name"
                        value="monthly_fee"
                      >
                        {{ groupAttributeData.monthly_fee.name }}
                      </option>
                      <option
                        v-if="groupAttributeData.custom_field_first.name"
                        :key="groupAttributeData.custom_field_first.name"
                        value="custom_field_first"
                      >
                        {{ groupAttributeData.custom_field_first.name }}
                      </option>
                      <option
                        v-if="groupAttributeData.custom_field_second.name"
                        :key="groupAttributeData.custom_field_second.name"
                        value="custom_field_second"
                      >
                        {{ groupAttributeData.custom_field_second.name }}
                      </option>
                    </select>
                  </td>
                  <td>
                    <select v-model="row.condition">
                      <option value=">">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.GREATER_THAN')
                      }}</option>
                      <option value=">=">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.GREATER_THAN_OR_EQUAL')
                      }}</option>
                      <option value="<">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.LESS_THAN')
                      }}</option>
                      <option value="<=">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.LESS_THAN_OR_EQUAL')
                      }}</option>
                      <option value="==">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.EQUAL')
                      }}</option>
                      <option value="!=">{{
                        $t('INBOX_MGMT.EDIT.VALIDATION.NOT_EQUAL')
                      }}</option>
                    </select>
                  </td>
                  <td>
                    <woot-input v-model="row.value" />
                  </td>
                  <td>
                    <woot-input v-model="row.classification" />
                  </td>
                  <td class="button-wrapper">
                    <div class="button-align">
                      <div class="nomargin-button">
                        <woot-button
                          v-tooltip.top-end="
                            $t('CONVERSATION.REPLYBOX.TIP_EMOJI_ICON')
                          "
                          class="nomargin-button"
                          icon="emoji"
                          emoji="😊"
                          color-scheme="primary"
                          class-names="grey-btn"
                          variant="smooth"
                          size="tiny"
                          @click="toggleEmojiPicker(row, index)"
                        />
                        <woot-button
                          v-tooltip.top="
                            $t('ATTRIBUTES_MGMT.LIST.BUTTONS.DELETE')
                          "
                          class="nomargin-button"
                          variant="smooth"
                          color-scheme="alert"
                          size="tiny"
                          icon="dismiss-circle"
                          class-names="grey-btn"
                          @click="removeRow(row.id, index)"
                        />
                      </div>
                      <div class="nomargin-button">
                        <woot-button
                          v-tooltip.top="$t('INBOX_MGMT.EDIT.MOVE_UP')"
                          class="nomargin-button"
                          variant="smooth"
                          size="tiny"
                          color-scheme="primary"
                          class-names="grey-btn"
                          icon="chevron-up"
                          :disabled="index === 0"
                          @click="moveRow(index, 'up')"
                        />
                        <woot-button
                          v-tooltip.top="$t('INBOX_MGMT.EDIT.MOVE_DOWN')"
                          class="nomargin-button"
                          variant="smooth"
                          size="tiny"
                          color-scheme="primary"
                          class-names="grey-btn"
                          icon="chevron-down"
                          :disabled="index === rows.length - 1"
                          @click="moveRow(index, 'down')"
                        />
                      </div>
                    </div>
                  </td>
                  <emoji-input
                    v-if="showEmojiPicker && selectedRow === index"
                    v-on-clickaway="hideEmojiPicker"
                    class="emoji-dialog--expanded"
                    :on-click="emoji => emojiOnClick(emoji, row)"
                  />
                </tr>
              </tbody>
            </table>
            <woot-button
              v-show="contactClassification"
              variant="smooth"
              size="medium"
              color-scheme="primary"
              @click="addRow"
            >
              {{ $t('INBOX_MGMT.EDIT.ADD_LINE') }}
            </woot-button>
          </label>

          <label
            v-if="isAWebWidgetInbox"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED') }}
            <select v-model="allowMessagesAfterResolved">
              <option :value="true">
                {{
                  $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.ENABLED')
                }}
              </option>
              <option :value="false">
                {{
                  $t('INBOX_MGMT.EDIT.ALLOW_MESSAGES_AFTER_RESOLVED.DISABLED')
                }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT'
                )
              }}
            </p>
          </label>

          <label
            v-if="isAWebWidgetInbox"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL') }}
            <select v-model="continuityViaEmail">
              <option :value="true">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.EDIT.ENABLE_CONTINUITY_VIA_EMAIL.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{
                $t(
                  'INBOX_MGMT.SETTINGS_POPUP.ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT'
                )
              }}
            </p>
          </label>
          <div class="medium-9 settings-item settings-item">
            <label>
              {{ $t('INBOX_MGMT.HELP_CENTER.LABEL') }}
            </label>
            <select v-model="selectedPortalSlug" class="filter__question">
              <option value="">
                {{ $t('INBOX_MGMT.HELP_CENTER.PLACEHOLDER') }}
              </option>
              <option v-for="p in portals" :key="p.slug" :value="p.slug">
                {{ p.name }}
              </option>
            </select>
            <p class="help-text">
              {{ $t('INBOX_MGMT.HELP_CENTER.SUB_TEXT') }}
            </p>
          </div>

          <label
            v-if="isEnableTranscription"
            class="medium-9 columns settings-item"
          >
            {{ $t('INBOX_MGMT.TRANSCRIPTION.LABEL') }}
            <select v-model="enableTranscription">
              <option :value="true">
                {{ $t('INBOX_MGMT.TRANSCRIPTION.ENABLED') }}
              </option>
              <option :value="false">
                {{ $t('INBOX_MGMT.TRANSCRIPTION.DISABLED') }}
              </option>
            </select>
            <p class="help-text">
              {{ $t('INBOX_MGMT.TRANSCRIPTION.SUB_TEXT') }}
            </p>
          </label>

          <label v-if="isAWebWidgetInbox">
            {{ $t('INBOX_MGMT.FEATURES.LABEL') }}
          </label>
          <div
            v-if="isAWebWidgetInbox"
            class="widget--feature-flag settings-item"
          >
            <input
              v-model="selectedFeatureFlags"
              type="checkbox"
              value="attachments"
              @input="handleFeatureFlag"
            />
            <label for="attachments">
              {{ $t('INBOX_MGMT.FEATURES.DISPLAY_FILE_PICKER') }}
            </label>
          </div>

          <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
            <input
              v-model="selectedFeatureFlags"
              type="checkbox"
              value="emoji_picker"
              @input="handleFeatureFlag"
            />
            <label for="emoji_picker">
              {{ $t('INBOX_MGMT.FEATURES.DISPLAY_EMOJI_PICKER') }}
            </label>
          </div>
          <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
            <input
              v-model="selectedFeatureFlags"
              type="checkbox"
              value="end_conversation"
              @input="handleFeatureFlag"
            />
            <label for="end_conversation">
              {{ $t('INBOX_MGMT.FEATURES.ALLOW_END_CONVERSATION') }}
            </label>
          </div>
          <div v-if="isAWebWidgetInbox" class="settings-item settings-item">
            <input
              v-model="selectedFeatureFlags"
              type="checkbox"
              value="use_inbox_avatar_for_bot"
              @input="handleFeatureFlag"
            />
            <label for="emoji_picker">
              {{ $t('INBOX_MGMT.FEATURES.USE_INBOX_AVATAR_FOR_BOT') }}
            </label>
          </div>
          <!-- QRCODE -->
          <div
            v-if="qrcodeWhatsapp"
            class="text-center medium-9 columns padding-2"
          >
            <qrcode-vue :value="qrcodeWhatsapp" :size="250" level="H" />
          </div>
          <!-- Buttons -->
          <div v-if="isAPIInbox" class="medium-9 columns text-center p-1">
            <woot-submit-button
              v-if="isAPIInbox"
              type="button"
              :disabled="
                $v.webhookUrl.$invalid ||
                  openConnection ||
                  $v.unassignedTimer.$invalid ||
                  $v.slaTimer.$invalid
              "
              :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
              :loading="uiFlags.isUpdating"
              @click="updateInbox"
            />
            <woot-submit-button
              type="button"
              :disabled="$v.webhookUrl.$invalid || openConnection"
              :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.CONNECT_DEVICE')"
              @click="connectQrWhatsappWeb"
            />

            <div class="restart-button-wrapper">
              <woot-submit-button
                v-if="showRestartButton"
                type="button"
                :disabled="isRestartDisabled()"
                :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.RESTART_WAPI')"
                @click="restartApi"
              />
              <div
                v-if="showRestartButton && isRestartDisabled()"
                class="custom-tooltip"
              >
                {{ getRestartTimeMessage() }}
              </div>
            </div>
          </div>
          <woot-submit-button
            v-else
            class="medium-9 columns text-center"
            type="submit"
            :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.UPDATE')"
            :loading="uiFlags.isUpdating"
            :disabled="$v.selectedInboxName.$invalid"
            @click="updateInbox"
          />
        </settings-section>
        <whatsapp-official-reonboard
          v-if="isAWhatsAppCloudChannel"
          :inbox="inbox"
        />
        <facebook-reauthorize v-if="isAFacebookInbox" :inbox-id="inbox.id" />
      </div>

      <div v-if="selectedTabKey === 'collaborators'" class="settings--content">
        <collaborators-page :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'configuration'">
        <configuration-page :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'preChatForm'">
        <pre-chat-form-settings :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'businesshours'">
        <weekly-availability :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'widgetBuilder'">
        <widget-builder :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'botConfiguration'">
        <bot-configuration :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'template'">
        <email-template-page v-if="isAnEmailChannel" :inbox="inbox" />
        <template-page v-else :inbox="inbox" />
      </div>
      <div v-if="selectedTabKey === 'calling'" class="settings--content">
        <whatsapp-calling-page :inbox="inbox" />
      </div>
    </div>
    <div v-if="showOnlyRestartButton()" class="">
      <setting-intro-banner
        :header-image="inbox.avatarUrl"
        :header-title="inboxName"
      >
        <div class="restart-button-wrapper">
          <woot-submit-button
            v-if="showRestartButton"
            type="button"
            :disabled="isRestartDisabled()"
            :button-text="$t('INBOX_MGMT.SETTINGS_POPUP.RESTART_WAPI')"
            @click="restartApi"
          />
          <div
            v-if="showRestartButton && isRestartDisabled()"
            class="custom-tooltip"
          >
            {{ getRestartTimeMessage() }}
          </div>
        </div>
      </setting-intro-banner>
    </div>
  </div>
</template>

<script>
import SettingIntroBanner from 'dashboard/components/widgets/SettingIntroBanner';
import QrcodeVue from 'qrcode.vue';
import { mixin as clickaway } from 'vue-clickaway';
import GreetingsEditor from 'shared/components/GreetingsEditor';
import {
  shouldBeUrl,
  isTimeEqualOrAfterMidnight,
} from 'shared/helpers/Validators';
import alertMixin from 'shared/mixins/alertMixin';
import configMixin from 'shared/mixins/configMixin';
import inboxMixin from 'shared/mixins/inboxMixin';
import {
  reconnectSessionOnService,
  restartSession,
} from 'shared/mixins/requestApiMixin';
import { io } from 'socket.io-client';
import { mapGetters } from 'vuex';
import SettingsSection from '../../../../components/SettingsSection';
import PreChatFormSettings from './PreChatForm/Settings';
import WidgetBuilder from './WidgetBuilder';
import BotConfiguration from './components/BotConfiguration';
import WeeklyAvailability from './components/WeeklyAvailability';
import FacebookReauthorize from './facebook/Reauthorize';
import CollaboratorsPage from './settingsPage/CollaboratorsPage';
import WhatsappOfficialReonboard from './settingsPage/WhatsappOfficialReonboard';
import WhatsappCallingPage from './settingsPage/WhatsappCallingPage';
import AttributeAPI from '../../../../api/attributes';
import ConfigurationPage from './settingsPage/ConfigurationPage';
import TemplatePage from './components/TemplatePage';
import EmailTemplatePage from './components/EmailTemplatePage';

const EmojiInput = () => import('shared/components/emoji/EmojiInput');

export default {
  components: {
    EmojiInput,
    BotConfiguration,
    CollaboratorsPage,
    ConfigurationPage,
    FacebookReauthorize,
    GreetingsEditor,
    PreChatFormSettings,
    SettingIntroBanner,
    SettingsSection,
    WeeklyAvailability,
    WidgetBuilder,
    QrcodeVue,
    WhatsappOfficialReonboard,
    WhatsappCallingPage,
    TemplatePage,
    EmailTemplatePage,
  },
  mixins: [alertMixin, configMixin, inboxMixin, clickaway],
  data() {
    return {
      avatarFile: null,
      avatarUrl: '',
      greetingEnabled: true,
      tweetsEnabled: true,
      greetingMessage: '',
      rows: [],
      groupRows: [],
      emailCollectEnabled: false,
      csatSurveyEnabled: false,
      slaEnabled: false,
      groupAttributeData: {},
      selectedRow: null,
      unassignedStatusTimeEnabled: false,
      assigneeOnSendMessage: false,
      firstResponseResolution: false,
      contactClassification: false,
      locktoSingleConversation: true,
      allowMessagesAfterResolved: true,
      continuityViaEmail: true,
      selectedInboxName: '',
      channelWebsiteUrl: '',
      webhookUrl: '',
      channelWelcomeTitle: '',
      channelWelcomeTagline: '',
      selectedFeatureFlags: [],
      replyTime: '',
      selectedTabIndex: 0,
      selectedClassificationTabIndex: 0,
      selectedPortalSlug: '',
      inboxConnection: false,
      classificationType: '',
      isWhatsapp: '',
      showEmojiPicker: false,
      qrcodeWhatsapp: null,
      openConnection: false,
      csatCustomMessage: '',
      csatSurveyMessage: '',
      slaTimer: '00:00',
      unassignedTimer: '00:00',
      enableTranscription: false,
      unassignedTimerAccountant: 1,
      lastWapiRestart: new Date(0),
      slaTimerAccountant: 1,
      sessionId: '',
      OPTIONS_SELECT_ACCOUNTANT: [
        {
          id: 1,
          name: this.$t('INBOX_MGMT.EDIT.ENABLE_SLA.OPTION_1'),
        },
        {
          id: 2,
          name: this.$t('INBOX_MGMT.EDIT.ENABLE_SLA.OPTION_2'),
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      getAccount: 'accounts/getAccount',
      accountId: 'getCurrentAccountId',
      currentRole: 'getCurrentRole',
      currentUser: 'getCurrentUser',
      isFeatureEnabledonAccount: 'accounts/isFeatureEnabledonAccount',
      uiFlags: 'inboxes/getUIFlags',
      portals: 'portals/allPortals',
    }),
    isEnableTranscription() {
      return this.getAccount(this.accountId)?.enable_transcription;
    },
    selectedTabKey() {
      return this.tabs[this.selectedTabIndex]?.key;
    },
    selectedClassificationTab() {
      return this.classificationTabs[this.selectedClassificationTabIndex]?.key;
    },
    attributes() {
      let attributeModel = '';

      if (this.selectedClassificationTabIndex === 0) {
        attributeModel = 'contact_attribute';
      }
      return this.$store.getters['attributes/getAttributesByModel'](
        attributeModel
      );
    },
    classificationTabs() {
      return [
        {
          key: 0,
          name: this.$t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.CONTACT_TAB'),
        },
        {
          key: 1,
          name: this.$t('INBOX_MGMT.EDIT.CONTACT_CLASSIFICATION.GROUP_TAB'),
        },
      ];
    },
    whatsAppAPIProviderName() {
      if (this.isAWhatsAppCloudChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.WHATSAPP_CLOUD');
      }
      if (this.is360DialogWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.360_DIALOG');
      }
      if (this.isATwilioWhatsAppChannel) {
        return this.$t('INBOX_MGMT.ADD.WHATSAPP.PROVIDERS.TWILIO');
      }
      return '';
    },
    tabs() {
      let visibleToAllChannelTabs = [
        {
          key: 'inbox_settings',
          name: this.$t('INBOX_MGMT.TABS.SETTINGS'),
        },
        {
          key: 'collaborators',
          name: this.$t('INBOX_MGMT.TABS.COLLABORATORS'),
        },
        {
          key: 'businesshours',
          name: this.$t('INBOX_MGMT.TABS.BUSINESS_HOURS'),
        },
      ];

      if (this.isAWebWidgetInbox) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'preChatForm',
            name: this.$t('INBOX_MGMT.TABS.PRE_CHAT_FORM'),
          },
          {
            key: 'widgetBuilder',
            name: this.$t('INBOX_MGMT.TABS.WIDGET_BUILDER'),
          },
        ];
      }

      if (
        this.isATwilioChannel ||
        this.isALineChannel ||
        this.isAPIInbox ||
        (this.isAnEmailChannel && !this.inbox.provider) ||
        (this.isAnEmailChannel && this.inbox.provider === 'microsoft') ||
        this.isAWhatsAppChannel ||
        this.isAWebWidgetInbox
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'configuration',
            name: this.$t('INBOX_MGMT.TABS.CONFIGURATION'),
          },
        ];
      }
      if (this.isAWhatsAppChannel || this.isAnEmailChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'template',
            name: this.isAnEmailChannel
              ? 'Templates'
              : this.$t('INBOX_MGMT.TABS.TEMPLATE'),
          },
        ];
      }

      if (this.isAWhatsAppCloudChannel) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'calling',
            name: this.$t('INBOX_MGMT.TABS.CALLING'),
          },
        ];
      }

      if (
        this.showBotConfiguration &&
        !(this.isAnEmailChannel || this.isATwitterInbox)
      ) {
        visibleToAllChannelTabs = [
          ...visibleToAllChannelTabs,
          {
            key: 'botConfiguration',
            name: this.$t('INBOX_MGMT.TABS.BOT_CONFIGURATION'),
          },
        ];
      }
      return visibleToAllChannelTabs;
    },
    currentInboxId() {
      return this.$route.params.inboxId;
    },
    calculateGroupAttributes() {
      return this.groupAttributes();
    },
    inbox() {
      return this.$store.getters['inboxes/getInbox'](this.currentInboxId);
    },

    inboxName() {
      if (this.isATwilioSMSChannel || this.isATwilioWhatsAppChannel) {
        return `${this.inbox.name} (${this.inbox.messaging_service_sid ||
          this.inbox.phone_number})`;
      }
      if (this.isAWhatsAppChannel) {
        return `${this.inbox.name} (${this.inbox.phone_number})`;
      }
      if (this.isAnEmailChannel) {
        return `${this.inbox.name} (${this.inbox.email})`;
      }
      return this.inbox.name;
    },
    showBotConfiguration() {
      return (
        this.currentUser?.type === 'SuperAdmin' ||
        this.currentUser?.role === 'administrator' ||
        this.currentUser?.permissions?.see_typebot_user
      );
    },
    showRestartButton() {
      return (
        this.currentUser?.type === 'SuperAdmin' ||
        this.currentUser?.role === 'administrator' ||
        this.currentUser?.permissions?.can_restart_api
      );
    },
    inboxNameLabel() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.LABEL');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.LABEL');
    },

    inboxNamePlaceHolder() {
      if (this.isAWebWidgetInbox) {
        return this.$t('INBOX_MGMT.ADD.WEBSITE_NAME.PLACEHOLDER');
      }
      return this.$t('INBOX_MGMT.ADD.CHANNEL_NAME.PLACEHOLDER');
    },
    textAreaChannels() {
      if (
        this.isATwilioChannel ||
        this.isATwitterInbox ||
        this.isAFacebookInbox
      )
        return true;
      return false;
    },
  },
  watch: {
    lastWapiRestart() {
      this.isRestartDisabled();
    },
    $route(to) {
      if (to.name === 'settings_inbox_show') {
        this.fetchInboxSettings();
      }
    },
  },
  mounted() {
    this.fetchInboxSettings();
    this.fetchPortals();
    this.groupAttributes();
  },
  methods: {
    showOnlyRestartButton() {
      return (
        this.currentUser?.type_role === 'agent' &&
        this.currentUser?.permissions?.can_restart_api
      );
    },
    async groupAttributes() {
      const rawData = await AttributeAPI.getGroupAttributes();
      this.groupAttributeData = rawData.data[0];
    },
    isRestartDisabled() {
      if (!this?.lastWapiRestart) return false;

      const FIVE_MINUTES = 5 * 60 * 1000;
      const now = new Date();
      const lastRestart = new Date(this.lastWapiRestart);

      return now - lastRestart < FIVE_MINUTES;
    },
    getRestartTimeMessage() {
      if (!this?.lastWapiRestart) return '';

      const FIVE_MINUTES = 5 * 60 * 1000;
      const lastRestart = new Date(this.lastWapiRestart);
      const nextRestartTime = new Date(lastRestart.getTime() + FIVE_MINUTES);

      const timeString = nextRestartTime.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false,
      });

      return `Próximo restart disponível às ${timeString}`;
    },
    handleClassificationType(e) {
      this.classificationType = e.target.value;
      this.selectedClassificationTabIndex =
        e.target.value === 'contact_attributes' ? 0 : 1;
    },
    fetchPortals() {
      this.$store.dispatch('portals/index');
    },
    handleFeatureFlag(e) {
      this.selectedFeatureFlags = this.toggleInput(
        this.selectedFeatureFlags,
        e.target.value
      );
    },
    toggleInput(selected, current) {
      if (selected.includes(current)) {
        const newSelectedFlags = selected.filter(flag => flag !== current);
        return newSelectedFlags;
      }
      return [...selected, current];
    },
    onTabChange(selectedTabIndex) {
      this.selectedTabIndex = selectedTabIndex;
    },
    updateAttributeKey(row) {
      if (this.classificationType === 'contact_attributes') {
        const selectedAttribute = this.attributes.find(
          attribute => attribute.id === row.custom_attribute
        );
        if (selectedAttribute) {
          row.attribute_name = selectedAttribute.attribute_key;
        }
      } else {
        row.attribute_name = row.custom_attribute;
      }
    },
    toggleEmojiPicker(row, index) {
      if (this.selectedRow === index) {
        this.showEmojiPicker = !this.showEmojiPicker;
      } else {
        this.selectedRow = index;
        this.showEmojiPicker = true;
      }
    },
    hideEmojiPicker() {
      this.showEmojiPicker = false;
      this.selectedRow = null;
    },
    emojiOnClick(emoji, row) {
      row.classification += emoji;
    },
    onClassificationTabChange(selectedIndex) {
      this.selectedClassificationTabIndex = selectedIndex;
    },
    fetchInboxSettings() {
      this.selectedTabIndex = 0;
      this.selectedAgents = [];
      this.$store.dispatch('agents/get');
      this.$store.dispatch('teams/get');
      this.$store.dispatch('labels/get');
      this.$store.dispatch('inboxes/get').then(() => {
        this.avatarUrl = this.inbox.avatar_url;
        this.selectedInboxName = this.inbox.name;
        this.webhookUrl = this.inbox.webhook_url;
        this.greetingEnabled = this.inbox.greeting_enabled || false;
        this.tweetsEnabled = this.inbox.tweets_enabled || false;
        this.greetingMessage = this.inbox.greeting_message || '';
        this.emailCollectEnabled = this.inbox.enable_email_collect;
        this.csatSurveyEnabled = this.inbox.csat_survey_enabled;
        this.slaEnabled = this.inbox.sla_enabled || false;
        this.unassignedStatusTimeEnabled =
          this.inbox.unassigned_status_time_enabled || false;
        this.assigneeOnSendMessage = this.inbox.assignee_on_message || false;
        this.slaTimerAccountant = this.inbox.sla_timer_accountant;
        this.unassignedTimerAccountant = this.inbox.unassigned_timer_accountant;
        this.firstResponseResolution = this.inbox.enable_first_contact_resolution;
        this.contactClassification =
          this.inbox.enable_contact_classification || false;
        this.classificationType = this.inbox.classification_type;
        this.selectedClassificationTabIndex =
          this.inbox.classification_type === 'contact_attributes' ? 0 : 1;
        this.allowMessagesAfterResolved = this.inbox.allow_messages_after_resolved;
        this.continuityViaEmail = this.inbox.continuity_via_email;
        this.channelWebsiteUrl = this.inbox.website_url;
        this.channelWelcomeTitle = this.inbox.welcome_title;
        this.channelWelcomeTagline = this.inbox.welcome_tagline;
        this.selectedFeatureFlags = this.inbox.selected_feature_flags || [];
        this.replyTime = this.inbox.reply_time;
        this.locktoSingleConversation = true;
        this.selectedPortalSlug = this.inbox.help_center
          ? this.inbox.help_center.slug
          : '';
        this.inboxConnection = this.inbox.connected;
        this.isWhatsapp = this.inbox.is_whatsapp;
        this.sessionId = this.inbox.session_id;
        this.csatCustomMessage = this.inbox.csat_custom_message;
        this.csatSurveyMessage = this.inbox.csat_survey_message;
        this.slaTimer = this.inbox.sla_timer;
        this.rows = this.inbox.contact_classification.filter(
          item => item.attribute_type === 'contact_attributes'
        );
        this.groupRows = this.inbox.contact_classification.filter(
          item => item.attribute_type === 'group_attributes'
        );
        this.unassignedTimer = this.inbox.unassigned_timer;
        this.enableTranscription = this.inbox?.enable_transcription;
        this.lastWapiRestart = this.inbox?.last_wapi_restart;
      });
    },
    moveRow(index, direction) {
      if (this.selectedClassificationTabIndex === 0) {
        if (direction === 'up' && index > 0) {
          this.swapRows(index, index - 1);
        } else if (direction === 'down' && index < this.rows.length - 1) {
          this.swapRows(index, index + 1);
        }
      } else if (direction === 'up' && index > 0) {
        this.swapRows(index, index - 1);
      } else if (direction === 'down' && index < this.groupRows.length - 1) {
        this.swapRows(index, index + 1);
      }
    },
    swapRows(index1, index2) {
      if (this.selectedClassificationTabIndex === 0) {
        const temp = this.rows[index1];
        this.$set(this.rows, index1, this.rows[index2]);
        this.$set(this.rows, index2, temp);
      } else {
        const temp = this.groupRows[index1];
        this.$set(this.groupRows, index1, this.groupRows[index2]);
        this.$set(this.groupRows, index2, temp);
      }
    },
    async updateLastWapiInbox() {
      try {
        const payload = {
          id: this.currentInboxId,
          last_wapi_restart: this.lastWapiRestart,
        };
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },
    async updateInbox() {
      try {
        const payload = {
          id: this.currentInboxId,
          name: this.selectedInboxName,
          enable_email_collect: this.emailCollectEnabled,
          csat_survey_enabled: this.csatSurveyEnabled,
          sla_enabled: this.slaEnabled,
          unassigned_status_time_enabled: this.unassignedStatusTimeEnabled,
          assignee_on_message: this.assigneeOnSendMessage,
          sla_timer_accountant: this.slaTimerAccountant,
          unassigned_timer_accountant: this.unassignedTimerAccountant,
          enable_first_contact_resolution: this.firstResponseResolution,
          enable_contact_classification: this.contactClassification,
          classification_type: this.classificationType,
          classification_array: [...this.rows, ...this.groupRows],
          allow_messages_after_resolved: this.allowMessagesAfterResolved,
          greeting_enabled: this.greetingEnabled,
          greeting_message: this.greetingMessage || '',
          portal_id: this.selectedPortalSlug
            ? this.portals.find(
                portal => portal.slug === this.selectedPortalSlug
              ).id
            : null,
          channel: {
            widget_color: this.inbox.widget_color,
            website_url: this.channelWebsiteUrl,
            welcome_title: this.channelWelcomeTitle || '',
            welcome_tagline: this.channelWelcomeTagline || '',
            selectedFeatureFlags: this.selectedFeatureFlags,
            reply_time: this.replyTime || 'in_a_few_minutes',
            tweets_enabled: this.tweetsEnabled,
            continuity_via_email: this.continuityViaEmail,
          },
          webhook_url: this.webhookUrl,
          connected: this.inboxConnection,
          is_whatsapp: this.isWhatsapp,
          csat_custom_message: this.csatCustomMessage,
          csat_survey_message: this.csatSurveyMessage,
          sla_timer: this.slaTimer,
          unassigned_timer: this.unassignedTimer,
          enable_transcription: this.enableTranscription,
          last_wapi_restart: this.lastWapiRestart,
        };
        if (this.avatarFile) {
          payload.avatar = this.avatarFile;
        }
        await this.$store.dispatch('inboxes/updateInbox', payload);
        this.showAlert(this.$t('INBOX_MGMT.EDIT.API.SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message || this.$t('INBOX_MGMT.EDIT.API.ERROR_MESSAGE')
        );
      }
    },

    addRow() {
      if (this.selectedClassificationTabIndex === 0) {
        this.rows.push({
          custom_attribute: '',
          condition: '',
          value: '',
          classification: '',
          attribute_type: 'contact_attributes',
        });
      } else {
        this.groupRows.push({
          custom_attribute: '',
          condition: '',
          value: '',
          classification: '',
          attribute_type: 'group_attributes',
        });
      }
    },
    async removeRow(id, index) {
      try {
        await this.$store.dispatch('inboxes/removeClassification', { id });
      } catch (error) {
        // Ensure catch block is not empty for linters
        // Log the error to aid debugging without breaking UX
        /* eslint-disable no-console */
        console.error(error);
        /* eslint-enable no-console */
      } finally {
        if (this.selectedClassificationTabIndex === 0) {
          this.rows.splice(index, 1);
        } else {
          this.groupRows.splice(index, 1);
        }
      }
    },
    handleImageUpload({ file, url }) {
      this.avatarFile = file;
      this.avatarUrl = url;
    },
    async handleAvatarDelete() {
      try {
        await this.$store.dispatch(
          'inboxes/deleteInboxAvatar',
          this.currentInboxId
        );
        this.avatarFile = null;
        this.avatarUrl = '';
        this.showAlert(this.$t('INBOX_MGMT.DELETE.API.AVATAR_SUCCESS_MESSAGE'));
      } catch (error) {
        this.showAlert(
          error.message
            ? error.message
            : this.$t('INBOX_MGMT.DELETE.API.AVATAR_ERROR_MESSAGE')
        );
      }
    },
    async restartApi() {
      const account = this.getAccount(this.accountId);
      this.apiUrl = account.url_whatsapp_web;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          account_gid: account.gid,
          session_id: this.sessionId,
        }),
      };

      this.lastWapiRestart = new Date();
      this.updateLastWapiInbox();

      try {
        const response = await restartSession(
          account.url_whatsapp_web,
          requestOptions
        );
        if (response === 201) {
          this.showAlert(
            this.$t('INBOX_MGMT.SETTINGS_POPUP.RESTART_WAPI_SUCCESS')
          );
        } else {
          this.showAlert(
            this.$t('INBOX_MGMT.SETTINGS_POPUP.RESTART_WAPI_ERROR')
          );
        }
      } catch (error) {
        this.showAlert(this.$t('INBOX_MGMT.SETTINGS_POPUP.RESTART_WAPI_ERROR'));
      }
    },
    connectQrWhatsappWeb() {
      const account = this.getAccount(this.accountId);
      this.apiUrl = account.url_whatsapp_web;

      this.openConnection = true;

      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          account_gid: account.gid,
          session_id: this.sessionId,
        }),
      };

      reconnectSessionOnService(account.url_whatsapp_web, requestOptions)
        .then(({ data }) => {
          this.showAlert(this.$t('INBOX_MGMT.SETTINGS_POPUP.QRCODE_MESSAGE'));

          const session_id = data?.session_id;
          this.qrcodeWhatsapp = data?.qr;

          if (session_id === '' || session_id === undefined) return;

          const socket = io(account.url_whatsapp_web);

          socket.on(`${session_id}-qrcode-generated`, qrcode => {
            this.qrcodeWhatsapp = qrcode;
          });

          socket.on(
            `${session_id}-client-connected`,

            () => {
              try {
                this.inboxConnection = true;
                this.qrcodeWhatsapp = null;
                this.openConnection = false;
                this.showAlert(
                  this.$t('INBOX_MGMT.SETTINGS_POPUP.DEVICE_CONNECTED')
                );
                socket.disconnect();
              } catch (error) {
                this.showAlert(
                  this.$t('INBOX_MGMT.SETTINGS_POPUP.DEVICE_CONNECTED_ERROR')
                );
              }
            }
          );
        })
        .catch(() => {
          setTimeout(() => {
            this.showAlert(
              this.$t('INBOX_MGMT.SETTINGS_POPUP.UNEXPECTED_ERROR_MESSAGE')
            );
            this.openConnection = false;
          }, 1000);
        });
    },
  },
  validations: {
    webhookUrl: {
      shouldBeUrl,
    },
    slaTimer: {
      isTimeEqualOrAfterMidnightt(values) {
        return this.slaEnabled ? isTimeEqualOrAfterMidnight(values) : true;
      },
    },
    unassignedTimer: {
      isTimeEqualOrAfterMidnightt(values) {
        return this.unassignedStatusTimeEnabled
          ? isTimeEqualOrAfterMidnight(values)
          : true;
      },
    },
    selectedInboxName: {},
  },
};
</script>

<style scoped lang="scss">
@import '~dashboard/assets/scss/variables';
@import '~dashboard/assets/scss/mixins';

.settings {
  background: var(--color-surface);

  .settings--tabs {
    ::v-deep .tabs {
      padding: 0;
    }
  }

  .emoji-dialog--expanded {
    right: 10vw;
    top: 40vh;
    position: fixed;
    z-index: var(--z-index-normal);

    &::before {
      transform: rotate(0deg);
      left: var(--space-smaller);
      bottom: var(--space-minus-small);
    }
  }

  .settings--content {
    div:last-child {
      border-bottom: 0;
    }
  }

  .tabs {
    padding: 0;
    margin-bottom: -1px;
  }
}

.button-align {
  display: flex;
  margin: 0px;
  flex-direction: row;
}

.nomargin-button {
  margin: 0px !important;
}

.widget--feature-flag {
  padding-top: var(--space-small);
}

.settings-item {
  padding-bottom: var(--space-normal);

  .help-text {
    font-style: normal;
    color: var(--b-500);
    padding-bottom: var(--space-smaller);
  }
}

.restart-button-wrapper {
  position: relative;
  display: inline-block;

  .custom-tooltip {
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: #333;
    color: white;
    padding: 8px 12px;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
    margin-bottom: 8px;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s, visibility 0.3s;

    &::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translateX(-50%);
      border: 5px solid transparent;
      border-top-color: #333;
    }
  }

  &:hover .custom-tooltip {
    opacity: 1;
    visibility: visible;
  }
}
</style>
